import {useEffect, useState} from 'react'
import {useContentfulClient} from './use-contentful-client.hook'
import {useIntl} from 'react-intl'

export const useGetCategorieInfo = ({slug = null}) => {
    const {locale} = useIntl()
    const contentfulClient = useContentfulClient()

    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState(null)
    const filter = slug ? {'fields.slug': slug, limit: 1} : {limit: 1000}

    useEffect(() => {
        setIsLoading(true)
        contentfulClient
            .getEntries({
                locale,
                ...filter,
                content_type: 'SFProductCategory',
                include: 10
            })
            .then((response) => {
                const items = response?.items ?? []
                if (items?.length)
                    setData(items.length > 1 ? items : items?.at(-1)?.fields)
            })
            .catch((error) => console.error('>>>> error', error))
            .finally(() => setIsLoading(false))
    }, [])

    return {data, isLoading}
}
